var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorizontalBarChart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "235px",
    height: "125px",
    viewBox: "0 0 235 125",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Widget/HorBar/RootCause/Simplified") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 235,
    height: 125,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Widget/HorBar/RootCause/Simplified",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    mask: "url(#mask-2)",
    fill: "#387997"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 6.214286)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L187.5,0 C189.985281,-4.56538782e-16 192,2.01471863 192,4.5 L192,5.14285714 C192,7.62813852 189.985281,9.64285714 187.5,9.64285714 L0,9.64285714 L0,9.64285714 L0,0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,21 L149.5,21 C151.985281,21 154,23.0147186 154,25.5 L154,26.1428571 C154,28.6281385 151.985281,30.6428571 149.5,30.6428571 L0,30.6428571 L0,30.6428571 L0,21 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,42 L145.5,42 C147.985281,42 150,44.0147186 150,46.5 L150,47.1428571 C150,49.6281385 147.985281,51.6428571 145.5,51.6428571 L0,51.6428571 L0,51.6428571 L0,42 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,62 L99.5,62 C101.985281,62 104,64.0147186 104,66.5 L104,67.1428571 C104,69.6281385 101.985281,71.6428571 99.5,71.6428571 L0,71.6428571 L0,71.6428571 L0,62 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,82.7857143 L81.5,82.7857143 C83.9852814,82.7857143 86,84.8004329 86,87.2857143 L86,88.2857143 C86,90.7709957 83.9852814,92.7857143 81.5,92.7857143 L0,92.7857143 L0,92.7857143 L0,82.7857143 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,104 L61.5,104 C63.9852814,104 66,106.014719 66,108.5 L66,109.142857 C66,111.628139 63.9852814,113.642857 61.5,113.642857 L0,113.642857 L0,113.642857 L0,104 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    mask: "url(#mask-2)",
    fill: "#D8D8D8"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.000000, 6.500000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 123,
    y: 0,
    width: 24,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 20.8,
    width: 24,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 41.6,
    width: 24,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 62.4,
    width: 24,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 83.2,
    width: 24,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 104,
    width: 24,
    height: 10
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalBarChart);
export default __webpack_public_path__ + "static/media/horizontal-bar-chart.96cca72cf6ead2453179a96d6d9a8f0e.svg";
export { ForwardRef as ReactComponent };